<template>
  <div class="a-editor">
    <!-- <quill-editor ref="a-editor" v-model="content" :options="option" @change="change" /> -->
  </div>
</template>

<script>
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// import { quillEditor } from 'vue-quill-editor';

// export default {
//   props: {
//     height: { type: String, default: () => '32vh' },
//     config: { type: Object, default: () => ({}) },
//     values: { type: String, default: () => '' },
//   },
//   components: {
//     quillEditor
//   },
//   data() {
//     return {
//       content: this.values,
//       option: {
//         placeholder: '编辑文章内容',
//         ...this.config
//       },
//     }
//   },
//   mounted() {
//     this.create();
//   },
//   methods: {
//     create() {
//       const container = document.getElementsByClassName('ql-editor')[0];
//       container && (container.style.minHeight = this.height);
//     },
//     change({ editor, html, text }) {
//       this.content = html;
//       this.$emit('input', html);
//       this.$emit('change', { html, text });
//     },
//   }
// }
</script>